import {DateRange} from "@angular/material/datepicker";
import moment from "moment";

moment()

export function rangeOverlaps(range1: DateRange<string | Date>, range2: DateRange<string | Date>) {
  return moment(range1.start).isSameOrBefore(moment(range2.end)) && moment(range1.end).isSameOrAfter(moment(range2.start));
}

export function rangeContains(parentRange: DateRange<string | Date>, childRange: DateRange<string | Date>): boolean {
  return moment(childRange.start).startOf("day").isSameOrAfter(moment(parentRange.start).startOf("day")) && moment(childRange.end).startOf("day").isSameOrBefore(moment(parentRange.end).startOf("day"))
}

export function isBefore(date1: string | Date, date2: string | Date) {
  return moment(date1).isBefore(moment(date2));
}

export function daysBetweenIncl(date1: string | Date, date2: string | Date | null) {
  if (!date2) {
    date2 = new Date();
  }
  return moment(date2).diff(moment(date1), 'days');
}

/**
 * Converts a Date (or a string in the format "yyyy-MM-dd") to an ISO string representing the start of that day.
 * If the input is null, returns null.
 *
 * @param dateInput A Date, or a string formatted as "yyyy-MM-dd", or null.
 * @returns An ISO string for the start of the day, or null if dateInput is null.
 */
export function toIsoDateStartOfDay(dateInput: Date | string | null): string | null {
  const dateObj = parseDateValue(dateInput);
  if (dateObj) {
    const startOfDay = new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate(), 0, 0, 0, 0);
    return startOfDay.toISOString();
  }
  return null;
}

/**
 * Converts a Date (or a string in the format "yyyy-MM-dd") to an ISO string representing the end of that day.
 * If the input is null, returns null.
 *
 * @param dateInput A Date, or a string formatted as "yyyy-MM-dd", or null.
 * @returns An ISO string for the end of the day, or null if dateInput is null.
 */
export function toIsoDateEndOfDay(dateInput: Date | string | null): string | null {
  const dateObj = parseDateValue(dateInput);
  if (dateObj) {
    const endOfDay = new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate(), 23, 59, 59, 999);
    return endOfDay.toISOString();
  }
  return null;
}

function parseDateValue(dateValue: string | Date | null): Date | null {
  if (dateValue == null) {
    return null;
  }
  let dateObj: Date;
  if (typeof dateValue === 'string') {
    // Assume format "yyyy-MM-dd"
    const parts = dateValue.split('-');
    if (parts.length !== 3) {
      throw new Error(`Invalid date format: ${dateValue}. Expected format is yyyy-MM-dd.`);
    }
    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // JavaScript months are 0-based.
    const day = parseInt(parts[2], 10);
    dateObj = new Date(year, month, day);
  } else {
    dateObj = dateValue;
  }
  return dateObj;
}
